import type { editor } from './types';
import Api from '@/services/Api';
import type { ActionTree } from 'vuex';
import { base } from '@/services/Endpoint';
import type { RootState } from '..';

const actions: ActionTree<editor, RootState> = {
  async updateShortcut({ state, commit }, data: boolean) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const payload = {
          status: data,
        };
        const res = await Api.base.post(base.updateShortcut, payload);
        if (res?.data?.status == 'success') {
          resolve(res.data);
        } else {
          reject(res?.data);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
};

export default actions;
